namespace Application.Models {
    'use strict';

    export interface IServerClientsInfo {
        slots: string[];
    }

    export class ServerClientsInfo implements IServerClientsInfo {
        public slots: string[];

        public static createEmpty(): ServerClientsInfo {
            return new ServerClientsInfo();
        }

        constructor() {
            this.slots = [];
        }
    }
}